import React from 'react';
import { Box, Stack, Grid, MenuItem, FormLabel, IconButton, InputAdornment, Typography, Checkbox, Divider, Button, Popover, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { StyledCard, StyledCardTitle, CustomSelect, SelectInputProps, FlexDiv, CustomSearch, CustomButton } from '../../../../../custom/components';
import { EditIcon, DeleteIcon, AddIcon, DateFormat, UploadIcon } from '../../../../../custom/constants';
import styles from '../../../../../custom/style.module.css';
import FlightScheduleModal from './FlightScheduleModal';
import flightStyles from './flights.module.css';
import commonStyles from '../../../common/common.module.css';
import moment from 'moment';
import { Search } from '@mui/icons-material';
import { dateTolocale } from 'utils/converter';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';

const flightSchedule = (props) => {

  // Popover action cell as a separate component
  function PopoverActionCell({ row }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setSelectedRow(row.logs);
    };
    const handleClose = () => {
      setAnchorEl(null);
      setSelectedRow(null);
    };
    const open = Boolean(anchorEl);
    return (
      <>
        <Button size='small'
          title='History'
          variant='contained'
          color='primary'
          className={styles.historyIcon}
          onClick={handleClick}
          disableElevation
          disableRipple
        >H 
        </Button>
        <Popover
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <List sx={{
            width: '100%',
            maxWidth: 360,
            minWidth: 320,
            bgcolor: 'background.paper',
            p: 2,
            maxHeight: 400,
            minHeight: 200,
          }}>
            {
              // this.state.loadingHistory ? 
              (selectedRow?.length > 0 ? 
                selectedRow.map((log, index) => (
                  <>
                    <ListItem key={index} className={commonStyles.historyListItem}>
                      <ListItemAvatar className={styles.mr2}>
                        <Typography variant='span' color='white'
                          bgcolor={log.action == 'CREATE' ? 'green' : log.action == 'UPDATE' ? 'blue' : log.action == 'DELETE' ? 'red' : 'grey'}
                          textTransform={'uppercase'} fontSize='10px' fontWeight={800} px={0.5} py={0.25} borderRadius={'4px'} lineHeight={'normal'} minWidth={'70px'} display={'block'} textAlign={'center'}>
                          {log.action == 'CREATE' ? 'Created' : log.action == 'UPDATE' ? 'Updated' : log.action == 'DELETE' ? 'Deleted' : log.action}
                        </Typography>
                      </ListItemAvatar>
                      <ListItemText
                        className={commonStyles.historyListText}
                        secondaryTypographyProps={{
                          fontSize: 12,
                          color: 'primary.main',
                          fontWeight: 500,
                        }}
                        primaryTypographyProps={{ fontSize: 12 }}
                        secondary={dateTolocale(log.date, 'DD MMM YYYY HH:mm') + ' | ' + (log.user.name ? log.user.name : (log.user.first_name || '') + ' ' + (log.user.last_name || '')) + ' (' + log.user?.role + ')'}
                        primary={log.action == 'CREATE' ? 'Created' : log.action == 'UPDATE' ? 'Updated' : log.action == 'DELETE' ? 'Deleted' : log.action} />
                    </ListItem>
                  </>
                )) :
                <Box sx={{
                  textAlign: 'center',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                  <Typography variant='span' color='textSecondary' fontSize='0.8rem'>No History Found</Typography></Box>)
              // :
              // Array.from({ length: 3 }).map((_, index) => <ListItem key={index}>
              //   <Skeleton variant='rectangular' width={300} height={100} />
              // </ListItem>)
            }
          </List>
        </Popover>
      </>
    );
  }
  const { scheduleList, handleOpen, handleClose, onChange, handleDelete } = props;
  const columns = [
    {
      id: 'select',
      accessorKey: 'select',
      enableSorting: false,
      header: () => { '-'; },
      cell: ({ row }) => {
        return <Checkbox
          inputProps={{ 'aria-label': 'Select' }}
          size='small'
          sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }}
          checked={props.selectedFlight.some(f => f.id === row.original.id)}
          onChange={() => {
            props.handleRowClick(row.original);
          }}
        />;
      },
    },
    {
      id: 'flight_no',
      header: 'Flight#',
      accessorFn: (row) => row.airline || '',
      cell: ({ row }) => {
        return `${row.original.airline} - ${row.original.flight_no}`;
      }

    },
    {
      id: 'org',
      header: 'Org-Dest',
      accessorFn: (row) => row?.org || '',
      cell: ({ row }) => {
        return `${row.original.org} - ${row.original.dest}`;
      }

    },
    {
      id: 'ac_type',
      accessorKey: 'ac_type',
      header: 'AC Type',
      cell: (info) => info.getValue(),

    },
    {
      id: 'platform',
      accessorKey: 'platform',
      header: 'Platform',
      cell: (info) => info.getValue(),

    },
    {
      id: 'std',
      accessorKey: 'std',
      header: 'STD',
      cell: (info) => info.getValue(),

    },
    {
      id: 'sta',
      accessorKey: 'sta',
      header: 'STA',
      cell: ({ row }) => {
        return `${row.original.sta} ${row.original.sta_next ? '+1' : ''}`;
      }

    },
    {
      id: 'from',
      accessorFn: (row) => row.from || '',
      header: 'From Date',
      cell: ({ row }) => {
        return `${moment(row.original.from, 'YYYY MM DD').format(DateFormat).toUpperCase()}`;
      },
      sortingFn: 'datetime',
    },
    {
      id: 'to',
      accessorFn: (row) => row.to || '',
      header: 'To Date',
      cell: ({ row }) => {
        return `${moment(row.original.to, 'YYYY MM DD').format(DateFormat).toUpperCase()}`;
      },
      sortingFn: 'datetime',
    },
    {
      id: 'days_of_ops',
      header: 'Days of Ops',
      accessorKey: 'days_of_ops',
      enableSorting: false,
      cell: ({ row }) => {
        return (
          <Stack direction='row' spacing={1}>
            <span className={`${flightStyles.days} ${!row.original.mon ? styles.disabledImg : ''}`}>1</span>
            <span className={`${flightStyles.days} ${!row.original.tue ? styles.disabledImg : ''}`}>2</span>
            <span className={`${flightStyles.days} ${!row.original.wed ? styles.disabledImg : ''}`}>3</span>
            <span className={`${flightStyles.days} ${!row.original.thu ? styles.disabledImg : ''}`}>4</span>
            <span className={`${flightStyles.days} ${!row.original.fri ? styles.disabledImg : ''}`}>5</span>
            <span className={`${flightStyles.days} ${!row.original.sat ? styles.disabledImg : ''}`}>6</span>
            <span className={`${flightStyles.days} ${!row.original.sun ? styles.disabledImg : ''}`}>7</span>
          </Stack>
        );
      },
    },
    {
      id: 'action',
      accessorKey: 'action',
      header: 'Action',
      meta: { align: 'center' },
      enableSorting: false,
      cell: ({ row }) => {
        return (
          <Stack direction='row' spacing={1} justifyContent='center' className={styles.actionIcons}>
            <PopoverActionCell row={row} />
            <EditIcon onClick={() => handleOpen('edit', row.original)} />
            <DeleteIcon onClick={(e) => { handleDelete(row.original.id, e.target); }} />
          </Stack>
        );
      }
    },
  ];

  return (
    <>
      <Grid container spacing={3} sx={{ height: 'calc(var(--contentBox) + 24px)' }}>
        <Grid item xs={12} sx={{ height: 'inherit' }}>
          <StyledCard sx={{
            height: 'calc(100% - 20px)',
            overflowX: 'auto'
          }}>
            <FlexDiv><StyledCardTitle>Current Flight Schedule</StyledCardTitle></FlexDiv>
            <Stack direction='row' alignItems={'center'} justifyContent='flex-end' spacing={2} mb={2} mt={'-24px'}>
              <FormLabel component='small' className={`${styles.xsW100}`}><small>Filter:</small> </FormLabel>
              <CustomSearch
                id='search'
                variant='outlined'
                size='small'
                type='search'
                placeholder='Search'
                name='search'
                value={props?.filter?.search || ''}
                onChange={props.onChangeFilter}
                InputProps={{
                  endAdornment: <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      aria-label='search'
                      edge='end'
                      onClick={props.filterData}
                    >
                      <Search fontSize='inherit' />
                    </IconButton>
                  </InputAdornment>,
                }}
                onKeyDown={
                  (e) => {
                    if (e.key === 'Enter') {
                      props.filterData(true);
                    }
                  }
                }
              />
              <CustomSelect
                {...SelectInputProps}
                id='airline'
                labelId='airline-label'
                fullWidth
                autoFocus
                onChange={props.onChangeFilter}
                name='airline'
                // className={billingStyles.tableTextField}
                style={{ width: '90px' }}
                value={!props?.filter?.airline ? false : props.filter.airline}
              // classes={{ select: !props.flightFields.airline ? styles.colorPlaceholder : '' }}
              >
                <MenuItem value='placeholder' disabled >Select Airline</MenuItem>
                <MenuItem value={false} >All</MenuItem>
                {props?.airlines?.map((airline, i) => (
                  <MenuItem key={i} value={airline}>
                    {airline}
                  </MenuItem>
                ))}
              </CustomSelect>
              <Divider orientation='vertical' variant='middle' flexItem sx={{
                backgroundColor: '#ffffff8f',
                height: '30px',
                '@media (max-width: 900px)': { display: 'none', }
              }} />
              <Box className={`${flightStyles.uploadBtn}`}>
                <div>
                  <input
                    accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xml, .xlsx'
                    style={{ display: 'none' }}
                    type='file'
                    id='ffm-file'
                    name='file'
                    onChange={props.handleUpload}
                    className={flightStyles.upload}
                  />
                  <label htmlFor='ffm-file' className={`${styles.fs0} ${flightStyles.uploadIcon} ${props.nil_manifest ? styles.disableIconBtn : ''}`}>
                    <Stack direction='row' spacing={1} alignItems='center'>
                      <UploadIcon className={`${styles.whiteSvg} ${flightStyles.uploadIcon}`} />
                      <Stack direction='column'>
                        <Typography variant='body2' component='span' textAlign='center' fontSize='13px'>
                          Upload Schedule
                        </Typography>
                        <Typography id='ffm-note' variant='caption' component='span' fontSize={'9px'} lineHeight='normal' marginTop={'-2px'} className={flightStyles.uploadedon}></Typography>
                      </Stack>
                    </Stack>
                  </label>
                </div>
              </Box>
              <CustomButton
                variant='contained'
                className={flightStyles.bulkDelete}
                onClick={props.handleBulkDelete}
                disabled={props.selectedFlight.length === 0}
              >
                Bulk Delete
              </CustomButton>
              <AddIcon className={styles.addIcon} title='Add Airline' onClick={() => props.handleOpen('add')} />
            </Stack>
            <Box className={styles.TStableWrapper} sx={{ height: 'calc(var(--contentBox) - 104px)', }}>
              <TableWrapper columns={columns} data={scheduleList} />
            </Box>
          </StyledCard>
        </Grid>
      </Grid>

      <FlightScheduleModal
        addSchedule={props.addSchedule}
        onChange={onChange}
        handleOpenAddUser={handleOpen}
        handleCloseSchedule={handleClose}
        openAddSchedule={props.openAddSchedule}
        flightFields={props.scheduleFields}
        handleOpen={handleOpen}
        flightErrors={props.scheduleErrors}
        type={props.type}
        changeDateTime={props.changeDateTime}
        changeCheck={props.changeCheck}
        airlines={props.airlineList}
        locationList={props.locationList}
        scheduleOrgDest={props.scheduleOrgDest} />
    </>
  );
};

export default flightSchedule;